import { render, staticRenderFns } from "./TraxTrainingCourseEditForm.vue?vue&type=template&id=087e4c6b"
import script from "./TraxTrainingCourseEditForm.vue?vue&type=script&lang=js"
export * from "./TraxTrainingCourseEditForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports